var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "elementType": "div",
      "customClass": _vm.$props.customsClasses
    }
  }, [_vm.showHeadingLabel ? _c('CustomText', {
    attrs: {
      "customClass": "buy-panel-size-selection-form-container-sizeqty-wrapper-ttl select-wrapper-text tile-selectors__title",
      "elementType": "div",
      "text": _vm.headingLabel
    }
  }) : _vm._e(), _vm._t("default"), _c('CustomContainer', {
    class: ['tile-selectors__wrapper', _vm.$props.itemCustomClass],
    attrs: {
      "elementType": "div"
    }
  }, _vm._l(_vm.tileList, function (value, indexForTile) {
    return _c('button', {
      key: _vm.tileKeyList[indexForTile] || value,
      class: ['tile-selectors__button', {
        'tile-selectors__button--active': (_vm.tileKeyList[indexForTile] || value) === _vm.$props.itemSelected
      }],
      attrs: {
        "disabled": _vm.buyPanelIsLoading
      },
      on: {
        "click": function click($event) {
          return _vm.clickEvent(_vm.tileKeyList[indexForTile] || value);
        }
      }
    }, [_vm._v("\n      " + _vm._s(value) + "\n    ")]);
  }), 0)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }